/* eslint-disable */
import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';

import "./styles/static-page.scss"
import "./styles/static-page-fix.css"
import "./styles/static-page-benefits.css"
